"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionType = exports.DocumentPermission = void 0;
exports.effectiveDocumentPermission = effectiveDocumentPermission;
exports.isPermissionType = isPermissionType;
exports.isGtPermissionType = isGtPermissionType;
exports.effectivePermissionType = effectivePermissionType;
exports.documentPermissionToPermissionType = documentPermissionToPermissionType;
exports.permissionTypeToDocumentPermission = permissionTypeToDocumentPermission;
const zod_1 = require("zod");
/**
 * New-style permission strings
 */
exports.DocumentPermission = zod_1.z.enum(["none", "edit", "view", "comment"]);
/**
 * The effective permission type is the highest permission granted among the contributing authorization types
 */
function effectiveDocumentPermission(...permissions) {
    if (permissions.includes(exports.DocumentPermission.Values.edit)) {
        return exports.DocumentPermission.Values.edit;
    }
    else if (permissions.includes(exports.DocumentPermission.Values.comment)) {
        return exports.DocumentPermission.Values.comment;
    }
    else if (permissions.includes(exports.DocumentPermission.Values.view)) {
        return exports.DocumentPermission.Values.view;
    }
    else {
        return exports.DocumentPermission.Values.none;
    }
}
/**
 * This is the legacy enum for integer values that represent permission levels
 *
 * Wherever possible, lets switch to using strings in the future, because they allow us to add new levels without
 * breaking existing code, and discourage relying on the numeric values here
 *
 * Soft-deprecated in favor of DocumentPermission
 */
var PermissionType;
(function (PermissionType) {
    PermissionType[PermissionType["none"] = 0] = "none";
    PermissionType[PermissionType["edit"] = 1] = "edit";
    PermissionType[PermissionType["view"] = 2] = "view";
    PermissionType[PermissionType["comment"] = 3] = "comment";
})(PermissionType || (exports.PermissionType = PermissionType = {}));
function isPermissionType(value) {
    return (typeof value === "string" || typeof value === "number") && value in PermissionType;
}
const PermissionTypeOrdering = {
    [PermissionType.none]: 0,
    [PermissionType.view]: 1,
    [PermissionType.comment]: 2,
    [PermissionType.edit]: 3,
};
function isGtPermissionType(pt1, pt2) {
    return PermissionTypeOrdering[pt1] > PermissionTypeOrdering[pt2];
}
/**
 * The effective permission type is the highest permission granted among the contributing authorization types
 */
function effectivePermissionType(...permissionTypes) {
    return documentPermissionToPermissionType(effectiveDocumentPermission(...permissionTypes.map(permissionTypeToDocumentPermission)));
}
/**
 * Converts a new-style permission to an old-style permission type integer
 */
function documentPermissionToPermissionType(permission) {
    switch (permission) {
        case exports.DocumentPermission.Values.none:
            return PermissionType.none;
        case exports.DocumentPermission.Values.edit:
            return PermissionType.edit;
        case exports.DocumentPermission.Values.view:
            return PermissionType.view;
        case exports.DocumentPermission.Values.comment:
            return PermissionType.comment;
    }
}
/**
 * Converts a old-style permission type integer to an new-style document permission string
 */
function permissionTypeToDocumentPermission(permissionType) {
    switch (permissionType) {
        case PermissionType.none:
            return exports.DocumentPermission.Values.none;
        case PermissionType.edit:
            return exports.DocumentPermission.Values.edit;
        case PermissionType.view:
            return exports.DocumentPermission.Values.view;
        case PermissionType.comment:
            return exports.DocumentPermission.Values.comment;
    }
}
//# sourceMappingURL=permissionType.js.map